import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2l0 -10","key":"svg-0"}],["path",{"d":"M14 9v6","key":"svg-1"}],["path",{"d":"M17 9l-2 3l2 3","key":"svg-2"}],["path",{"d":"M15 12h-1","key":"svg-3"}],["path",{"d":"M7 9.5a.5 .5 0 0 1 .5 -.5h1a1.5 1.5 0 0 1 0 3h-.5h.5a1.5 1.5 0 0 1 0 3h-1a.5 .5 0 0 1 -.5 -.5","key":"svg-4"}]]

const IconBadge3k = createReactComponent('outline', 'badge-3k', 'Badge3k', __iconNode);

export default IconBadge3k;